import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class CookiesService {

  constructor(private cookieService: CookieService) { }

  public getCookieValue(cookieName: string): string {
    return this.cookieService.get(cookieName);
  }

  public setCookieValue(cookieName: string, cookieValue: string): void {
    this.cookieService.set(cookieName, cookieValue, {path: '/'});
  }
}
